export const mediaItems = [
  {
    id: 1,
    title: '长相思',
    tag: '古装玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20scene%20with%20ethereal%20characters%20in%20flowing%20robes%2C%20misty%20mountain%20landscape%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20soft%20dreamy%20atmosphere%2C%20period%20costume%20drama%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
    episodes: '39集全',
    status: '已完结',
    heat: '9.7',
  },
  {
    id: 2,
    title: '庆余年 第二季',
    tag: '古装权谋',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20political%20drama%20with%20scheming%20officials%20in%20ancient%20court%20costumes%2C%20grand%20palace%20interior%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20cinematic%20quality%2C%20warm%20and%20dark%20tones&width=640&height=360&seq=media-02&orientation=landscape',
    episodes: '36集全',
    status: '已完结',
    heat: '9.8',
  },
  {
    id: 3,
    title: '繁花',
    tag: '都市年代',
    cover: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20urban%20drama%20with%20stylish%20characters%20in%20retro%20fashion%2C%20neon%20city%20lights%2C%20elegant%20restaurant%20scene%2C%20nostalgic%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20tones&width=640&height=360&seq=media-03&orientation=landscape',
    episodes: '30集全',
    status: '已完结',
    heat: '9.6',
  },
  {
    id: 4,
    title: '狂飙',
    tag: '涉案刑侦',
    cover: 'https://readdy.ai/api/search-image?query=Contemporary%20Chinese%20crime%20thriller%20drama%20with%20detectives%20investigating%2C%20urban%20night%20scenes%2C%20tense%20dramatic%20lighting%2C%20cinematic%20film%20noir%20style%2C%20dark%20and%20moody%20atmosphere%2C%20professional%20photography&width=640&height=360&seq=media-04&orientation=landscape',
    episodes: '39集全',
    status: '已完结',
    heat: '9.9',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-slideshow-3-line',
    title: '极速加载 不缓冲',
    desc: '采用先进CDN加速与智能预加载技术，全网热门电视剧秒开即播，告别卡顿等待，畅享零缓冲追剧体验。',
  },
  {
    id: 2,
    icon: 'ri-vip-crown-line',
    title: '全集免费 免VIP',
    desc: '所有电视剧全集免费在线观看，无需会员付费，无需注册登录，打开网页就能直接追剧，真正实现全民免费看。',
  },
  {
    id: 3,
    icon: 'ri-4k-line',
    title: '高清画质 流畅追剧',
    desc: '全平台支持1080P高清画质，智能码率自适应，无论电脑还是手机都能享受清晰流畅的电视剧观看体验。',
  },
];

export const contactInfo = {
  title: '投稿与合作',
  desc: '如果你有好的影视资源、原创剧评或合作意向，欢迎通过以下方式联系我们。成全影视致力于打造开放共赢的影视内容生态。',
  email: '',
  wechat: '',
};

export const appInfo = {
  title: '随时随地 追剧不设限',
  desc: '成全影视移动端适配已全面优化，无需下载App，通过手机浏览器即可流畅访问，享受与桌面端一致的追剧体验。支持iOS与Android全平台。',
  features: ['无需安装', '流量优化', '画质自适应', '全平台支持'],
};

export const indexItems = [
  { id: 1, title: '古装仙侠专题', count: 286, tag: '热门' },
  { id: 2, title: '都市情感剧场', count: 412, tag: '推荐' },
  { id: 3, title: '悬疑推理合集', count: 198, tag: '新番' },
  { id: 4, title: '历史权谋大剧', count: 156, tag: '经典' },
  { id: 5, title: '科幻奇幻世界', count: 134, tag: '新番' },
  { id: 6, title: '青春校园回忆', count: 247, tag: '热门' },
  { id: 7, title: '涉案刑侦剧场', count: 173, tag: '推荐' },
  { id: 8, title: '年代传奇巨制', count: 98, tag: '经典' },
  { id: 9, title: '喜剧轻松一刻', count: 321, tag: '热门' },
];

export const topicItems = [
  { id: 1, name: '#长相思大结局', heat: '1280万' },
  { id: 2, name: '#庆余年第二季', heat: '1560万' },
  { id: 3, name: '#繁花沪语版', heat: '890万' },
  { id: 4, name: '#古装剧文艺复兴', heat: '720万' },
  { id: 5, name: '#国产悬疑天花板', heat: '650万' },
  { id: 6, name: '#高口碑年代剧', heat: '580万' },
  { id: 7, name: '#不缓冲追剧体验', heat: '510万' },
  { id: 8, name: '#暑期追剧清单', heat: '960万' },
  { id: 9, name: '#新剧开播日历', heat: '430万' },
  { id: 10, name: '#豆瓣高分国剧', heat: '380万' },
  { id: 11, name: '#演技封神名场面', heat: '1040万' },
];

export const carouselItems = [
  {
    id: 1,
    title: '三体',
    tag: '科幻巨制',
    desc: '刘慈欣同名小说改编，中国科幻电视剧里程碑之作，用震撼视觉呈现宇宙尺度的文明博弈。',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20Chinese%20drama%20with%20cosmic%20universe%20scenes%2C%20futuristic%20technology%2C%20mysterious%20alien%20civilization%2C%20dramatic%20space%20visuals%2C%20cinematic%20quality%2C%20dark%20and%20deep%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=carousel-01&orientation=landscape',
    rating: '9.5',
  },
  {
    id: 2,
    title: '漫长的季节',
    tag: '悬疑生活',
    desc: '跨越二十年的东北悬疑故事，以细腻笔触描绘时代洪流下小人物的命运交织与人性抉择。',
    cover: 'https://readdy.ai/api/search-image?query=Northeast%20China%20industrial%20town%20in%20autumn%2C%20suspenseful%20drama%20atmosphere%2C%20nostalgic%201990s%20setting%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20melancholy%20mood%2C%20professional%20film%20photography&width=800&height=450&seq=carousel-02&orientation=landscape',
    rating: '9.8',
  },
  {
    id: 3,
    title: '去有风的地方',
    tag: '治愈田园',
    desc: '逃离都市喧嚣，在大理遇见温暖人情与慢生活，一部让人想立刻出发的治愈系田园剧。',
    cover: 'https://readdy.ai/api/search-image?query=Dali%20Yunnan%20rural%20landscape%20with%20traditional%20courtyard%2C%20gentle%20sunlight%2C%20blue%20sky%20and%20white%20clouds%2C%20healing%20pastoral%20atmosphere%2C%20warm%20natural%20lighting%2C%20cinematic%20quality%2C%20peaceful%20and%20relaxing%20vibe&width=800&height=450&seq=carousel-03&orientation=landscape',
    rating: '9.4',
  },
  {
    id: 4,
    title: '莲花楼',
    tag: '武侠探案',
    desc: '江湖奇案与侠义精神交织，以精巧的案件设计和深厚的武侠底蕴重塑经典江湖叙事。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20drama%20with%20warriors%20in%20traditional%20robes%2C%20misty%20bamboo%20forest%2C%20dramatic%20fight%20choreography%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20dark%20green%20tones&width=800&height=450&seq=carousel-04&orientation=landscape',
    rating: '9.3',
  },
  {
    id: 5,
    title: '异人之下',
    tag: '奇幻异能',
    desc: '动漫改编真人剧巅峰之作，异人世界的热血冒险与都市异能设定碰撞出全新火花。',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20Chinese%20drama%20with%20superpower%20characters%2C%20modern%20city%20at%20night%20with%20neon%20lights%2C%20dynamic%20action%20scenes%2C%20comic%20book%20aesthetic%2C%20cinematic%20quality%2C%20vibrant%20and%20energetic%20atmosphere&width=800&height=450&seq=carousel-05&orientation=landscape',
    rating: '9.1',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '唐朝诡事录之西行',
    tag: '古装志怪',
    desc: '延续第一季精良制作，以盛唐为背景展开诡谲奇案，画面质感与悬疑氛围全面升级。',
    cover: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20mystery%20drama%20poster%20with%20ancient%20Chinese%20officials%20investigating%2C%20dark%20mysterious%20atmosphere%2C%20traditional%20costumes%2C%20lantern%20lighting%2C%20cinematic%20portrait%20style%2C%20warm%20amber%20and%20dark%20tones&width=400&height=560&seq=card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '猎罪图鉴',
    tag: '犯罪心理',
    desc: '画像师与刑警联手破案，以独特的艺术视角切入犯罪心理，每案独立又暗线勾连。',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20with%20detective%20sketching%20portrait%2C%20dark%20studio%20setting%2C%20dramatic%20lighting%2C%20psychological%20tension%2C%20cinematic%20portrait%20photography%2C%20moody%20noir%20atmosphere&width=400&height=560&seq=card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '少年歌行',
    tag: '热血武侠',
    desc: '少年意气与江湖恩怨交织，热血成长线搭配精美特效，展现新一代武侠剧的蓬勃朝气。',
    cover: 'https://readdy.ai/api/search-image?query=Young%20martial%20arts%20heroes%20drama%20poster%2C%20dynamic%20action%20pose%2C%20flowing%20robes%2C%20dramatic%20wind%20effects%2C%20warm%20sunset%20lighting%2C%20cinematic%20fantasy%20style%2C%20vibrant%20and%20energetic&width=400&height=560&seq=card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '云之羽',
    tag: '古装谍战',
    desc: '宫门谍影重重，以精美的服化道与紧凑的谍战叙事打破传统古装剧套路，悬疑感拉满。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20spy%20drama%20poster%20with%20elegant%20characters%20in%20flowing%20silk%20robes%2C%20palace%20intrigue%2C%20mysterious%20atmosphere%2C%20soft%20diffused%20lighting%2C%20cinematic%20portrait%2C%20ethereal%20and%20suspenseful&width=400&height=560&seq=card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '大奉打更人',
    tag: '穿越探案',
    desc: '现代人穿越古代成为打更人，以科学思维破解奇案，轻松幽默中暗藏烧脑推理。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20time%20travel%20mystery%20drama%20poster%2C%20ancient%20detective%20with%20modern%20mindset%2C%20night%20watchman%20setting%2C%20lantern%20lit%20streets%2C%20mysterious%20and%20playful%20atmosphere%2C%20cinematic%20portrait%20photography&width=400&height=560&seq=card-05&orientation=portrait',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: '',
    time: '2小时前',
    content: '成全影视真的是我用过最流畅的追剧网站，狂飙全集一口气看完，全程没有缓冲过，画质也很清晰，已经推荐给身边所有朋友了！',
    likes: 1286,
    show: '狂飙',
  },
  {
    id: 2,
    name: '深夜煲剧人',
    avatar: '',
    time: '5小时前',
    content: '找了很久的繁花沪语版，终于在成全影视看到了，画质超棒而且全集免费，不用开会员就能看真的太良心了。',
    likes: 953,
    show: '繁花',
  },
  {
    id: 3,
    name: '古装剧十级学者',
    avatar: '',
    time: '8小时前',
    content: '长相思的服化道和演技都在线，成全影视更新速度也快，每次更新当天就能看到，不用到处找资源，收藏了！',
    likes: 2104,
    show: '长相思',
  },
  {
    id: 4,
    name: '悬疑控',
    avatar: '',
    time: '12小时前',
    content: '漫长的季节太好哭了，演技全员在线。在成全影视上二刷了，这种高质量国产剧值得反复看。',
    likes: 1678,
    show: '漫长的季节',
  },
  {
    id: 5,
    name: '周末追剧人',
    avatar: '',
    time: '1天前',
    content: '朋友推荐来的，没想到界面这么清爽，没有乱七八糟的广告弹窗。庆余年第二季全集已经追完，现在开始补三体！',
    likes: 745,
    show: '庆余年 第二季',
  },
];

export const updateItems = [
  {
    id: 1,
    date: '07-31',
    title: '《唐朝诡事录之西行》全36集更新完毕，开启盛唐探案之旅',
    tag: '完更',
  },
  {
    id: 2,
    date: '07-30',
    title: '平台全面升级CDN节点，追剧加载速度大幅提升',
    tag: '公告',
  },
  {
    id: 3,
    date: '07-29',
    title: '《三体》导演剪辑版独家上线，新增30分钟未公开内容',
    tag: '独家',
  },
  {
    id: 4,
    date: '07-28',
    title: '暑期档专题页面上线，百部热剧一网打尽陪你过夏天',
    tag: '活动',
  },
  {
    id: 5,
    date: '07-27',
    title: '《大奉打更人》预约人数突破500万，即将定档开播',
    tag: '预告',
  },
  {
    id: 6,
    date: '07-26',
    title: '手机端播放体验优化完成，移动追剧更省流量更清晰',
    tag: '优化',
  },
  {
    id: 7,
    date: '07-25',
    title: '《猎罪图鉴》第二季官宣原班人马回归，敬请期待',
    tag: '预告',
  },
  {
    id: 8,
    date: '07-24',
    title: '成全影视日活跃用户突破800万，感谢每一位追剧人',
    tag: '里程碑',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '狂飙', tag: '涉案刑侦', heat: '9.9', trend: 'up' },
  { id: 2, rank: 2, title: '庆余年 第二季', tag: '古装权谋', heat: '9.8', trend: 'up' },
  { id: 3, rank: 3, title: '漫长的季节', tag: '悬疑生活', heat: '9.8', trend: 'stable' },
  { id: 4, rank: 4, title: '长相思', tag: '古装玄幻', heat: '9.7', trend: 'down' },
  { id: 5, rank: 5, title: '繁花', tag: '都市年代', heat: '9.6', trend: 'stable' },
  { id: 6, rank: 6, title: '三体', tag: '科幻巨制', heat: '9.5', trend: 'up' },
];

export const aboutContent = {
  title: '关于成全影视',
  paragraphs: [
    '成全影视是一个专注提供电视剧全集免费在线观看的平台，致力于为广大追剧用户打造高清流畅、无需VIP的看剧体验。我们聚合了海量热门电视剧资源，涵盖古装玄幻、都市情感、悬疑推理、历史权谋、科幻奇幻等多种题材，满足不同观众的追剧需求。',
    '我们的核心理念是"不缓冲看剧，全集免费追"。通过持续升级的CDN加速技术和智能码率自适应方案，确保每位用户无论使用何种设备，都能享受到零缓冲、高画质的电视剧观看体验。成全影视日活跃用户超过800万，已成为众多追剧爱好者的首选平台。',
    '我们将持续更新优质电视剧内容，不断优化播放体验，让每一位来到成全影视的用户都能轻松找到想看的剧，流畅看完全集。追剧，本该如此简单。',
  ],
  stats: [
    { value: '10,000+', label: '热门电视剧' },
    { value: '800万+', label: '日活跃用户' },
    { value: '50+', label: '每日更新剧集' },
    { value: '99.9%', label: '服务可用率' },
  ],
};

export const faqItems = [
  {
    id: 1,
    question: '成全影视真的完全免费吗？需要注册会员吗？',
    answer: '是的，成全影视所有电视剧内容均免费在线观看，无需注册账号，无需开通会员，无需支付任何费用。打开网站即可直接搜索和播放您想看的电视剧全集。我们通过广告合作维持运营，确保用户可以零门槛追剧。',
  },
  {
    id: 2,
    question: '观看电视剧会卡顿吗？画质怎么样？',
    answer: '成全影视采用先进的CDN加速网络和智能码率自适应技术，绝大多数用户可实现零缓冲流畅播放。平台默认提供1080P高清画质，同时支持根据您的网络状况自动调整最佳清晰度，确保流畅与画质的平衡。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？手机上能看吗？',
    answer: '成全影视全面支持PC端、平板和手机端浏览器访问。无需下载任何App或插件，通过手机浏览器即可流畅追剧。我们对移动端做了深度优化，在保证画质的同时大幅降低流量消耗，让您随时随地畅享追剧乐趣。',
  },
  {
    id: 4,
    question: '新剧更新速度快吗？多久能看上最新剧集？',
    answer: '成全影视拥有高效的资源更新团队，热门电视剧通常在首播当天即可上线。每日更新超过50部剧集内容，涵盖各平台热播新剧和经典老剧。您可以通过首页"最新动态"模块实时了解更新信息，也可以通过搜索功能直接查找想看的电视剧。',
  },
];